<template lang="pug">
v-container(fluid align="start" class="tw-px-4 fill-height tw-content-start tw-h-screen tw-overflow-hidden")
  div(v-if="component" class="tw-h-full tw-w-full")
    v-fade-transition(mode="out-in")
      component(:is="component") 
  div(v-else class=" tw-w-full tw-h-full tw-max-h-full")
    v-fade-transition(mode="out-in")
      kubiqa-nav-sidebar-default
</template>

<script>
export default {
  data() {
    return {
      component: null,
    };
  },
  watch: {
    '$route.meta.section'(to, from) {
      switch (to) {
        case 'opportunities':
          this.component = () => import('@/views/Opportunities/Sidebar/Main.vue');
          break;
        // case 'opportunity':
        //   this.component = () => import('@/views/Opportunities/Sidebar/Main.vue');
        //   break;
        default:
          this.component = null;
          break;
      }
    },
  },
};
</script>
